import styled from 'styled-components'

import { CheckboxProps } from 'core/components/lib/Checkbox/Checkbox'
import variables from 'core/styles/variables'

const OuterContainer = styled.div<{ margin: CheckboxProps['margin'] }>`
  /* This defines a block-level element for the
  ** component, meaning it will take up the
  ** same amount of width space as an inlin-block
  ** element but also start on a new line */
  display: table;
  margin: ${(p) => p.margin};
`
const InnerContainer = styled.div<{
  flexReverse: CheckboxProps['flexReverse']
  labelPosition: CheckboxProps['labelPosition']
}>`
  position: relative;
  align-items: center;
  ${(p) => (p.flexReverse ? `flex-direction: row-reverse;` : '')}
  ${(p) => (p.labelPosition === 'top' ? 'padding: 0 0 32px;' : '')}

  .spinner {
    top: 0;
    left: 2px;
  }
`
const CheckboxLabel = styled.label<
  Pick<CheckboxProps, 'padding' | 'flexReverse' | 'labelPosition' | 'color' | 'fontSize'>
>`
  position: relative;
  display: block;
  padding: ${(p) =>
    p.padding ? p.padding
    : p.flexReverse ? '0 32px 0 0'
    : '0 0 0 32px'};
  ${(p) => (p.labelPosition === 'top' ? 'padding: 0;' : '')}
  font-size: ${(p) => p.fontSize || '16px'};
  line-height: 20px;
  color: ${(p) => p.color || variables.colorBlack90};
  cursor: pointer;

  &::before,
  &::after {
    position: absolute;
    box-sizing: border-box;
    content: '';
    border-radius: 10%;
  }

  &::before {
    ${(p) =>
      p.labelPosition === 'top' ?
        `
          left: 50%;
          transform: translateX(-50%);
          bottom: -24px;
        `
      : p.flexReverse ? 'top: 0; right: 0;'
      : 'top: 0; left: 0;'}
    width: 20px;
    height: 20px;
  }

  &::after {
    ${(p) =>
      p.labelPosition === 'top' ?
        `
          left: calc(50% - 5px);
          transform: translateX(-50%);
          bottom: -16px;`
      : p.flexReverse ? 'top: 9px; right: 13px;'
      : 'top: 9px; left: 5px;'}
    width: 2px;
    height: 2px;
  }
`
const CheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  display: none;

  &:checked + ${CheckboxLabel}::before {
    background-color: ${(p) => p.theme.secondary};
    border: 2px solid ${(p) => p.theme.primary};
  }

  &:not(:checked) + ${CheckboxLabel}::before {
    background-color: ${variables.colorWhite};
    border: 2px solid ${variables.colorBlack70};
  }

  &:checked + ${CheckboxLabel}::after {
    background: white;
    box-shadow:
      2px 0 0 white,
      4px 0 0 white,
      4px -2px 0 white,
      4px -4px 0 white,
      4px -6px 0 white,
      4px -8px 0 white;
    transition: all 0.2s ease-in;
    transform: rotate(45deg);
  }
  &:not(:checked):not(:indeterminate) + ${CheckboxLabel}::after {
    opacity: 0;
    transform: scale(0);
  }

  &:indeterminate + ${CheckboxLabel}::after {
    width: 10px;
    background: ${variables.colorBlack70};
    transition: all 0.2s ease-in;
  }
  &:disabled:indeterminate + ${CheckboxLabel}::after {
    background: white;
  }

  &:checked + ${CheckboxLabel}:after, &:indeterminate + ${CheckboxLabel}::after {
    opacity: 1;
  }

  &:disabled + ${CheckboxLabel} {
    cursor: not-allowed;
  }

  &:disabled + ${CheckboxLabel}::before {
    background-color: ${variables.colorBlack50};
    border: 2px solid ${variables.colorBlack50};
  }
`

export { InnerContainer, CheckboxInput, CheckboxLabel, OuterContainer }
